<template>
  <section>
    <div class="mx-4 sm:mx-2">
      <h2>What flavour would you like?</h2>
      <div class="flavours sm:flex">
        <standard-button 
          v-for="item in filteredFlavours" :key="item.id"
          @click="setFlavour(item.id)"
          :active="value == item.id"
        >
          {{item.name}}
        </standard-button>
      </div>
      <p class="text-sm text-gray-700 mt-2" v-if="showAdditional">Don't see the flavour you are after?<br/>Add it to the "Any additional instructions" section during checkout</p>
      
    </div>
  </section>
</template>


<script>
import StandardButton from './FlavourButton'
import { filter, map, find } from 'lodash'
export default {
  model: {
    value: 'value',
    event: 'input'
  },
  props: {
    value: {},
    sku: {},
    flavours: {}
  },
  components: {
    StandardButton
  },
  methods: {
    setFlavour(id) {
      this.$emit('input', id)
      this.$scrollTo(document.getElementById('message'), 1000, { offset: -50 })
    }
  },
  computed: {
    showAdditional() {
      return !(this.flavours && this.flavours.length > 0)
    },
    filteredFlavours() {
      if(this.flavours && this.flavours.length > 0) {
        return map(this.flavours, o => find(this.$root.$data.flavours, {id: o.id}))
      } else {
        return filter(this.$root.$data.flavours, {cakes: "YES"})
      }
    }
  }
}
</script>
